/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Configuration files */
import { addAmendmentsConfig } from "./AddAmendments.formfield.config";


/** Utilities */
import { setDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** RTK Query */
import { useAddContractAmendmentTypeMutation, useLazyGetAllContractInstallmentTypesQuery } from "../../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import { format_Date } from "../../../../../../../components/finalMolGrid/libs/formatDate";
import { ContractContext } from "../../../../../../../utils/context/ContractContext";
import PropTypes from "prop-types";

const AddAmendments = (props) => {
  const { contractId, onClose, getAmendmentsList } = props;
  const AddAmendmentsRef = useRef();
  const [amendmentformData, setAmendmentFormData] = useState(addAmendmentsConfig);
  const { contractData } = useContext(ContractContext);

  const [addContractAmendmentType, {
    isLoading: isAddContractAmendmentTypeLoading,
    isSuccess: isAddContractAmendmentTypeFetching,
    data: addContractAmendmentData
  }] = useAddContractAmendmentTypeMutation();

  const [getAllContractInstallmentTypes, {
    isFetching: isAllContractInstallmentTypesFetching,
    isSuccess: isAllContractInstallmentTypesFetched,
    data: allContractInstallmentTypesData,
  },] = useLazyGetAllContractInstallmentTypesQuery();

  useEffect(() => {
    getAllContractInstallmentTypes(false);
    setFieldSetting(amendmentformData, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isAllContractInstallmentTypesFetching && isAllContractInstallmentTypesFetched && allContractInstallmentTypesData) {
      setDropdownOptions(allContractInstallmentTypesData, 'lInstallmentTypeID', 'sInstallmentType', amendmentformData, 'lInstallmentTypeID', setAmendmentFormData);
      setFieldSetting(amendmentformData, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllContractInstallmentTypesFetching, isAllContractInstallmentTypesFetched, allContractInstallmentTypesData])


  useEffect(() => {
    if (isAddContractAmendmentTypeFetching && addContractAmendmentData) {
      if (addContractAmendmentData) {
        ToastService.success(addContractAmendmentData?.errorMessage);
        getAmendmentsList(contractId)
        onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddContractAmendmentTypeFetching, addContractAmendmentData]);

  useEffect(() => {
      const form = { ...addAmendmentsConfig };
      form.initialState = {
        dtEfectiveDate: contractData.dtDateEffective ? new Date(contractData.dtDateEffective) : null,
        dtTeminationDate: contractData.dtDateTermination ? new Date(contractData.dtDateTermination) : null,
        dtAmendmentDate: new Date(),
        lInstallmentTypeID: contractData.lInstallmentTypeID ? extractValue(contractData.lInstallmentTypeID) : null,
      }
      setAmendmentFormData(form)
  }, [contractData]);

  const extractValue = (field) => {
    return field && typeof field === "object" ? field.value : field;
  };

  const handleSave = () => {
    const formData = AddAmendmentsRef.current.getFormData();
    if(!formData)
    {
      ToastService.error("Please fill all required fields");
      return;
    }
    const request = {
      plContractKey: contractId,
      pdtContractAmendmentDate: format_Date(formData?.dtAmendmentDate),
      pnPreviousInvoiceAmount: 0,
      pdtFirstBillDate: format_Date(formData?.dtFirstBillDate)
    };
    addContractAmendmentType(request);
  }

  const handleOnBlur = (fieldName, value) => {
    if (fieldName !== "dtFirstBillDate") return;

    const firstBill = format_Date(value?.dtFirstBillDate);
    const effective = format_Date(value?.dtEfectiveDate);
    const termination = format_Date(value?.dtTeminationDate);

    if (!firstBill) return;

    if (effective && firstBill < effective) {
      return ToastService.error(
        "The First Bill Date cannot be prior to the Effective Date."
      );
    }

    if (termination && firstBill >= termination) {
      return ToastService.error(
        "The First Bill Date cannot be on or after the Contract Termination Date."
      );
    }
  };


  return (
      <div className="row">
        <FormCreator ref={AddAmendmentsRef} config={amendmentformData} onFormFieldChange={(field, val) => handleOnBlur(field, val)} />
        <div className="d-flex justify-content-end gap-3 mt-3">
            <Buttons
            buttonText="Save"
            onClick={handleSave}
            buttonTypeClassName="btn blue-btn"
            titleText="Unassign Selected Items"
            isLoading={isAddContractAmendmentTypeLoading}
          />
          <Buttons
            buttonText="Cancel"
            onClick={onClose}
            buttonTypeClassName="btn dark-btn"
            titleText="Unassign Selected Items"
          />
        </div>
      </div>
  );
};

AddAmendments.propTypes = {
  isOpen: PropTypes.bool,
  contractId: PropTypes.number,
  getAmendmentsList: PropTypes.func,
  onClose: PropTypes.func,
};

export default AddAmendments;
